import React from "react";

const defaultRights = {};

export const RightsContext = React.createContext(defaultRights);
